export default {
  'redeemCoupon.title': 'Redeem Coupon',
  'redeemCoupon.message.one': 'It will deduct',
  'redeemCoupon.message.two': 'points and convert to',
  'redeemCoupon.unit': 'Piece',
  'redeemCoupon.exchange_success': 'Redemption Successful',
  'redeemCoupon.exchange_fail': 'Redemption Failed',
  'redeemCoupon.no_service.one': 'Currently, there is no coupon redemption service available',
  'redeemCoupon.no_service.two': 'For inquiries, please contact the brand’s customer service',
  'redeemCoupon.button': 'Redeem',
  'redeemCoupon.ok_text.one': 'Yes',
  'redeemCoupon.ok_text.two': 'OK',
  'redeemCoupon.getting_time': 'Coupon Collection Time',
  'redeemCoupon.time.start': 'Start',
  'redeemCoupon.time.end': 'End',
} as Record<string, string>;
